import React from 'react'
import { inject, observer } from 'mobx-react'
import { Text, View, TouchableOpacity } from 'react-native'
import { Box } from 'native-base'
import Home from '../../components/Home'
import LocalizationContext from '../../context/LocalizationContext'
import qs from 'qs'
import Loading from '../../components/basic/Loading'

function HomeScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { notificationStore, navigation } = props



    React.useEffect(() => {
        const focus = navigation.addListener('focus', async () => {
            try {
                console.log('focus')
            }
            catch (e) {
                console.log(e)
            }
        })
        return focus
    }, [navigation])


    return (
        <Home
            t={t}
            onPress={(route) => {return navigation.push(route)}}
        />
    )
}

export default inject('notificationStore')(observer(HomeScreen))
